// // This is admin panel sidebar code
//
// import React, {useState} from "react";
// import {useLocation, useNavigate} from "react-router-dom";
// import {Layout} from "antd";
// import {
//     FileTextOutlined,
//     HomeOutlined,
//     LogoutOutlined,
//     ProfileOutlined,
//     TeamOutlined,
//     TrophyOutlined,
// } from "@ant-design/icons";
//
// const {Sider} = Layout;
//
// const Sidebar = () => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const [collapsed, setCollapsed] = useState(false);
//
//     // Define menu items
//     const menuItems = [
//         {text: "Home", icon: <HomeOutlined/>, path: "/HomePage"},
//         {text: "View Students", icon: <TeamOutlined/>, path: "/viewstudents"},
//         {text: "View Teachers", icon: <TeamOutlined/>, path: "/viewteachers"},
//         {text: "View Parents", icon: <TeamOutlined/>, path: "/viewparents"},
//         {text: "Student Reports", icon: <FileTextOutlined/>, path: "/report"},
//         {text: "Leaderboard", icon: <TrophyOutlined/>, path: "/leaderboard"},
//         {text: "Profile", icon: <ProfileOutlined/>, path: "/Profile"},
//         {text: "Logout", icon: <LogoutOutlined/>, path: "Logout"},
//     ];
//
//     const handleMenuClick = (path, text) => {
//         if (text === "Logout") {
//             localStorage.removeItem("accessToken");
//             navigate("/"); // Redirect to home or login page after logout
//         } else if (text === "collapse") {
//             setCollapsed(!collapsed);
//         } else {
//             navigate(path);
//         }
//     };
//
//     return (
//         <div
//             className="pt-6 h-screen w-full"
//             style={{
//                 backgroundColor: "#000000", // Black background
//                 padding: "12px 8px",
//                 fontFamily: "Gotham, sans-serif",
//             }}
//         >
//             {/* Logo Section */}
//             <div
//                 className="logo"
//                 style={{
//                     color: "#FAD049", // Yellow color for logo
//                     textAlign: "center",
//                     padding: "16px",
//                     fontSize: "22px", // Slightly larger logo font size
//                     fontWeight: "bold",
//                     fontFamily: "League Spartan, sans-serif", // Typography for heading
//                     textTransform: "uppercase",
//                 }}
//             >
//                 Edumonics
//             </div>
//
//             {/* Menu Items */}
//             <div
//                 className="menu"
//                 style={{
//                     marginTop: "24px",
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "16px", // Spacing between menu items
//                 }}
//             >
//                 {menuItems.map((item, index) => (
//                     <div
//                         key={index}
//                         onClick={() => handleMenuClick(item.path, item.text)}
//                         style={{
//                             display: "flex",
//                             alignItems: "center",
//                             padding: "12px 16px",
//                             borderRadius: "12px",
//                             backgroundColor: location.pathname === item.path ? "#FAD049" : "transparent", // Highlight active menu
//                             cursor: "pointer",
//                             transition: "background-color 0.3s ease",
//                         }}
//                     >
//             <span
//                 style={{
//                     color: location.pathname === item.path ? "#000000" : "#FAD049", // Icon color
//                     fontSize: "20px",
//                     marginRight: "12px",
//                 }}
//             >
//               {item.icon}
//             </span>
//                         <span
//                             style={{
//                                 color: location.pathname === item.path ? "#000000" : "#FFFFFF", // Text color
//                                 fontSize: "16px",
//                                 fontWeight: "500",
//                             }}
//                         >
//               {item.text}
//             </span>
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
//
// };
//
// export default Sidebar;

import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {
    Home,
    Users,
    GraduationCap,
    UserCheck,
    FileText,
    Trophy,
    User,
    LogOut,
    ChevronLeft,
    ChevronRight,
    Shield,
    Building2,
    BarChart3,
    Settings,
    Activity,
    UserCog,
    Database
} from "lucide-react";

// Color constants
const COLORS = {
    primary: "#F17C45",
    secondary: "#4365FD",
    background: "#0F172A",
    cardBg: "#1E293B",
    activeBg: "#334155",
    text: "#E2E8F0",
    textSecondary: "#94A3B8",
    accent: "#F59E0B",
    border: "#334155"
};

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);

    // Define menu items with Lucide React icons for Super Admin
    const menuGroups = [
        {
            label: "Overview",
            items: [
                {key: "dashboard", text: "Dashboard", icon: <Home size={20}/>, path: "/HomePage"},
            ],
        },
        {
            label: "Tenant operations",
            items: [
                {key: "schools", text: "Schools Management", icon: <Building2 size={20}/>, path: "/schools"},
            ],
        },
        {
            label: "Governance",
            items: [
                {key: "audit", text: "Audit Logs", icon: <FileText size={20}/>, path: "/audit-logs"},
            ],
        },
        {
            label: "Account",
            items: [
                {key: "logout", text: "Logout", icon: <LogOut size={20}/>, path: "Logout"},
            ],
        },
    ];

    const handleMenuClick = (path, text) => {
        if (text === "Logout") {
            localStorage.removeItem("accessToken");
            navigate("/"); // Redirect to home or login page after logout
        } else if (text === "collapse") {
            setCollapsed(!collapsed);
        } else {
            navigate(path);
        }
    };

    const handleCollapseClick = () => {
        setCollapsed(!collapsed);
    };

    // Check if the menu item is active
    const isActive = (path) => location.pathname === path;

    return (
        <div
            className={`
                h-screen bg-slate-900 text-slate-200 font-[poppins]
                transition-all duration-300 ease-in-out
                ${collapsed ? 'w-20' : 'w-64'}
                flex flex-col relative z-20
                border-r border-slate-700
                shadow-2xl shadow-slate-900/50
            `}
            style={{backgroundColor: COLORS.background}}
        >
            {/* Header/Logo Section */}
            <div className={`
                flex items-center justify-center font-[poppins]
                ${collapsed ? 'px-4 py-4' : 'px-4 py-4'}
                border-b border-slate-700
                bg-gradient-to-r from-slate-800 to-slate-900
            `}>
                {!collapsed ? (
                    <div className="flex font-[poppins] items-center gap-3">
                        <div
                            className="w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-lg">
                            <Shield size={24} className="text-white"/>
                        </div>
                        <span
                            className="text-2xl font-[poppins] font-bold tracking-wide uppercase"
                            style={{color: COLORS.primary}}
                        >
                            EDUMONICS
                        </span>
                    </div>
                ) : (
                    <div
                        className="w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-lg">
                        <Shield size={24} className="text-white"/>
                    </div>
                )}
            </div>

            {/* Super Admin Panel Indicator */}
            {!collapsed && (
                <div className="px-6 py-4 border-b border-slate-700">
                    <div
                        className="bg-gradient-to-r from-orange-500/10 to-red-500/10 rounded-lg p-3 border border-orange-500/20">
                        <div className="text-xs text-slate-400 uppercase tracking-wider mb-1">Access Level</div>
                        <div className="text-sm font-semibold text-orange-400">
                            Super Administrator
                        </div>
                        <div className="text-xs text-slate-500 mt-1">
                            Multi-Tenant Management
                        </div>
                    </div>
                </div>
            )}

            {/* Menu Items */}
            <div className="flex-1 px-3 py-4 overflow-y-auto">
                {menuGroups.map((group, groupIndex) => (
                    <section key={group.label} className={groupIndex ? "mt-3" : ""}>
                        {!collapsed && (
                            <h2 className="px-3 pb-1 pt-2 text-[10px] font-bold uppercase tracking-[.14em] text-slate-500">
                                {group.label}
                            </h2>
                        )}
                        <div className="space-y-1">
                            {group.items.map((item, index) => {
                    const active = isActive(item.path);
                    const isHovered = hoveredItem === item.key;

                    return (
                        <div
                            key={item.key}
                            onClick={() => handleMenuClick(item.path, item.text)}
                            onMouseEnter={() => setHoveredItem(item.key)}
                            onMouseLeave={() => setHoveredItem(null)}
                            className={`
                                group relative flex items-center gap-4 px-3 py-3
                                rounded-xl cursor-pointer transition-all duration-200
                                ${active
                                ? 'bg-gradient-to-r from-orange-500/20 to-orange-600/20 border border-orange-500/30'
                                : isHovered
                                    ? 'bg-slate-800/60 border border-slate-600/50'
                                    : 'border border-transparent hover:bg-slate-800/40'
                            }
                                transform hover:scale-105 hover:shadow-lg hover:shadow-orange-500/10
                            `}
                            style={{
                                animationDelay: `${index * 0.05}s`,
                                animation: 'slideInFromLeft 0.3s ease-out forwards'
                            }}
                        >
                            {/* Active indicator */}
                            {active && (
                                <div
                                    className="absolute left-0 top-1/2 transform -translate-y-1/2 w-1 h-8 rounded-r-full"
                                    style={{backgroundColor: COLORS.primary}}
                                />
                            )}

                            {/* Icon */}
                            <div className={`
                                flex items-center justify-center w-8 h-8
                                ${active ? 'text-orange-400' : isHovered ? 'text-blue-400' : 'text-slate-400'}
                                transition-colors duration-200
                            `}>
                                {item.icon}
                            </div>

                            {/* Text */}
                            {!collapsed && (
                                <span className={`
                                    text-sm font-medium transition-colors duration-200
                                    ${active ? 'text-orange-300' : isHovered ? 'text-blue-300' : 'text-slate-300'}
                                `}>
                                    {item.text}
                                </span>
                            )}

                            {/* Tooltip for collapsed state */}
                            {collapsed && (
                                <div className={`
                                    absolute left-full ml-3 px-3 py-2 bg-slate-800 text-white text-sm
                                    rounded-lg shadow-lg opacity-0 group-hover:opacity-100
                                    transition-all duration-200 pointer-events-none z-50
                                    border border-slate-600
                                    ${isHovered ? 'translate-x-0' : 'translate-x-2'}
                                `}>
                                    {item.text}
                                    <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-1
                                        w-2 h-2 bg-slate-800 rotate-45 border-l border-b border-slate-600"/>
                                </div>
                            )}
                        </div>
                    );
                            })}
                        </div>
                    </section>
                ))}
            </div>

            {/* Collapse Toggle Button */}
            <div className="border-t border-slate-700 p-4">
                <button
                    onClick={handleCollapseClick}
                    className={`
                        w-full flex items-center justify-center gap-3 px-4 py-3
                        bg-gradient-to-r from-slate-800 to-slate-700
                        hover:from-slate-700 hover:to-slate-600
                        border border-slate-600 hover:border-slate-500
                        rounded-xl transition-all duration-200
                        text-slate-300 hover:text-orange-300
                        shadow-lg hover:shadow-xl
                        transform hover:scale-105
                        group
                    `}
                >
                    <div className="flex items-center justify-center">
                        {collapsed ? (
                            <ChevronRight size={18} className="group-hover:text-orange-400 transition-colors"/>
                        ) : (
                            <>
                                <ChevronLeft size={18} className="group-hover:text-orange-400 transition-colors"/>
                                <span className="text-sm font-medium ml-2">Collapse</span>
                            </>
                        )}
                    </div>
                </button>
            </div>

            {/* Gradient overlay for visual depth */}
            <div
                className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-slate-900/20 pointer-events-none"/>

            <style jsx>{`
                @keyframes slideInFromLeft {
                    from {
                        opacity: 0;
                        transform: translateX(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
            `}</style>
        </div>
    );
};

export default Sidebar;
